import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopoverModulesComponent } from './popover-modules/popover-modules.component';
import { PopoverListComponent } from './popover-list/popover-list.component';
import { NotificationComponent } from './notification/notification.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { ToggleMenuComponent } from './toggle-menu/toggle-menu.component';
import { TranslateComponent } from './translate/translate.component';
import { IconsModule } from './icons/icons.module';
import { ModalUsersComponent } from './modal-users/modal-users.component';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalPasskeysComponent } from './modal-passkeys/modal-passkeys.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { ModalAddUsersGroupsComponent } from './modal-add-users-groups/modal-add-users-groups.component';
import { ModalDeleteComponent } from './modal-delete/modal-delete.component';
import { ModalGroupsUsersComponent } from './modal-groups-users/modal-groups-users.component';
import { FilterComponent } from './filter/filter.component';
import { S3UploadModule } from './s3-upload/s3-upload.module';
import { SplashComponent } from './splash/splash.component';
import { ModalVersionComponent } from './modal-version/modal-version.component';
import { AddressModalModule } from './address-modal/address-modal.module';

function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}
@NgModule({
  declarations: [
    PopoverModulesComponent,
    PopoverListComponent,
    NotificationComponent,
    ToggleMenuComponent,
    TranslateComponent,
    ModalUsersComponent,
    ModalPasskeysComponent,
    FilterComponent,
    ModalGroupsUsersComponent,
    ModalDeleteComponent,
    ModalAddUsersGroupsComponent,
    SplashComponent,
    ModalVersionComponent,
  ],
  imports: [
    CommonModule,
    IconsModule,
    MatIconModule,
    ReactiveFormsModule,
    FormsModule,
    MatMenuModule,
    S3UploadModule,
    MatSelectModule,
    MatChipsModule,
    MatDialogModule,
    AddressModalModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [
    ModalPasskeysComponent,
    PopoverModulesComponent,
    PopoverListComponent,
    NotificationComponent,
    ToggleMenuComponent,
    TranslateComponent,
    ModalUsersComponent,
    FilterComponent,
    ModalGroupsUsersComponent,
    ModalDeleteComponent,
    ModalAddUsersGroupsComponent,
    SplashComponent,
    ModalVersionComponent,
  ],
})
export class ComponentsMangoLayoutModule {}
